import { Tag } from 'antd';
import { FC, memo } from 'react';

import { SearchConsoleAccountProcessStatus } from '@/modules/Domains';
import { Site } from '@/modules/Sites';

type Props = Pick<Site, 'searchConsoleAccountProcessStatus' | 'searchConsoleAccount'>;

export const SiteDomainsSearchConsoleProcessingStatusTag: FC<Props> = memo(({ searchConsoleAccountProcessStatus: status, searchConsoleAccount }) => {
  if (status === SearchConsoleAccountProcessStatus.Set) return <Tag color="blue">Додання</Tag>;

  if (status === SearchConsoleAccountProcessStatus.Unset) return <Tag color="geekblue">Видалення</Tag>;

  if (status === SearchConsoleAccountProcessStatus.Pending) return (
    <Tag color="orange">{ `В черзі на ${ searchConsoleAccount ? 'видалення' : 'додання' }` }</Tag>
  );

  return <></>;
});
